var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icn/saved") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn/saved",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_save_24px",
    transform: "translate(4.000000, 4.000000)",
    fill: "#CCCCCC",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4444444,0 L1.77777778,0 C0.791111111,0 0,0.8 0,1.77777778 L0,14.2222222 C0,15.2 0.791111111,16 1.77777778,16 L14.2222222,16 C15.2,16 16,15.2 16,14.2222222 L16,3.55555556 L12.4444444,0 Z M8,14.2222222 C6.52444444,14.2222222 5.33333333,13.0311111 5.33333333,11.5555556 C5.33333333,10.08 6.52444444,8.88888889 8,8.88888889 C9.47555556,8.88888889 10.6666667,10.08 10.6666667,11.5555556 C10.6666667,13.0311111 9.47555556,14.2222222 8,14.2222222 Z M10.6666667,5.33333333 L1.77777778,5.33333333 L1.77777778,1.77777778 L10.6666667,1.77777778 L10.6666667,5.33333333 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaved);
export default __webpack_public_path__ + "static/media/saved.ac05d5f50ff6a795518df940f1cfa13f.svg";
export { ForwardRef as ReactComponent };